import { LOCALES } from '@/model/locales'
import { loadLanguageAsync } from '@/plugins/i18n'

export const enforceLocale = async (to, from, next) => {
    if (to.query.locale && LOCALES.includes(to.query.locale)) {
        await loadLanguageAsync(to.query.locale)
    }
    next()
}
